import { useMemo, useContext } from 'react';

import { useLocation, matchPath } from 'react-router-dom';

import { CustomerContext } from '../../../context-providers/CustomerContext';
import { ROUTES } from '../../../routes';

export type BreadcrumbItem = {
  label: string;
  path?: string;
};

export const useBreadcrumbs = (): BreadcrumbItem[] => {
  const location = useLocation();
  const { selectedCustomer } = useContext(CustomerContext);

  return useMemo(() => {
    const { pathname } = location;

    // Match customer page
    const customerMatch = matchPath(
      {
        path: ROUTES.customer.$path(),
        end: false,
      },
      pathname,
    );

    if (customerMatch) {
      const customerName = selectedCustomer?.full_name || 'Loading...';
      return [{ label: 'Customers', path: ROUTES.customers.$path() }, { label: customerName }];
    }

    // Match customers list page
    if (matchPath(ROUTES.customers.$path(), pathname)) {
      return [{ label: 'Customers' }];
    }

    // Match activities page
    if (matchPath(ROUTES.activities.$path(), pathname)) {
      return [{ label: 'Activities' }];
    }

    // Match AI Agent page
    if (matchPath(ROUTES.aiAgent.$path(), pathname)) {
      return [{ label: 'AI Agent' }];
    }

    // Match calls page
    if (matchPath(ROUTES.calls.$path(), pathname)) {
      return [{ label: 'Calls' }];
    }

    // Match orders page
    if (matchPath(ROUTES.orders.$path(), pathname)) {
      return [{ label: 'Orders' }];
    }

    // Match sales toolkit page
    if (matchPath(ROUTES.salesToolkit.$path(), pathname)) {
      return [{ label: 'Sales Toolkit' }];
    }

    // Default empty breadcrumbs
    return [];
  }, [location, selectedCustomer]);
};
